import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '../../data.service';

@Component({
  selector: "lc-assets-page",
  templateUrl: "./assets-page.component.html",
  styleUrls: ["./assets-page.component.scss"],
})
export class AssetsPageComponent implements OnInit {
  public paramFilter: string; // use this if we get a filter from the params and make it active
  public selectedAsset: any;

  // this belongs to the new asset page. Should STILL be simplified.
  public translatedAssets: any;
  public translatedAssetFilters: any;

  private assets = [];
  private filteredAssets = [];

  public config = {
    title: "Assets",
    status: "ASSET",
    background: "background--clear",
    searchbar: true,
    filterbar: true,
    categories: true,
    view_type: "list",
    previewMode: false,
    printMode: false,
  };
  private known_pages = {
    zoom: {
      filter: "Zoom!",
      config: {
        title: "Zoom! Training",
        status: "ASSET",
        background: "background--zoom",
        searchbar: false,
        filterbar: false,
        categories: false,
        view_type: "grid",
        previewMode: false,
        printMode: false,
      },
    },
    studies: {
      filter: "",
      config: {
        title: "Clinical Studies Library",
        status: "STUDY",
        background: "background--studies",
        searchbar: true,
        filterbar: true,
        categories: false,
        view_type: "grid",
        previewMode: false,
        printMode: false,
      },
    },
  };
  private predefined_list_nl = [
    "Tandenborstels",
    "Opzetborstels",
    "Opzetborstels (standaard)",
    "Opzetborstels (compact)",
    "Interdentaal",
    "Speciaal voor de praktijk & medewerker",
    "Bleken in de praktijk",
    "Thuis bleken",
    "Mondverzorging",
    "Marketingmaterialen",
    "Gepersonaliseerde middelen",
  ];
  private predefined_list_en = [
    "In chair whitening",
    "In office whitening",
    "Take home whitening",
    "Accessories",
    "Utilities",
  ];
  private predefined_list = this.predefined_list_nl.concat(
    this.predefined_list_en
  );

  // use this to filter
  public activeFilters = [];
  public activeFilterGroups = {};

  public activeKeywords = "";

  public filterCount;

  public loading = true;

  constructor(public dataService: DataService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.known_pages["clinical"] = this.known_pages.studies; // alias
    this.getAssets();

    this.route.params.subscribe((params) => {
      // if we have params, select the single item from all products
      if (!!params["pid"]) {
        // set preview mode
        this.setPreviewOrPrintMode(params);
      }
      if (!!params["type"]) {
        const clean_type = params["type"].toLowerCase().replace(/[\W_]+/g, "");
        if (!!this.known_pages[clean_type]) {
          this.paramFilter = this.known_pages[clean_type].filter;
          this.config = { ...this.known_pages[clean_type].config };
          // also do this after rechecking the params, else it won't update filters
          this.getAssets();
        }
      }
    });
  }

  onLanguageChange(language: string) {
    this.assets = this.dataService.process_assets(this.assets);
  }

  getAssets() {
    // should be replaced with seperate assets call
    this.dataService.get_assets().subscribe(
      (assets) => {
        return this.processAssets(assets);
      },
      (error) => {
        this.loading = false;
        console.warn(error);
      },
      () => {
        this.loading = false; // done retrieving info
      }
    );
  }

  get_cat(SKU) {
    if (SKU === 'MP4') return 'Video';
    if (SKU === 'PDF') return 'PDF';
    return 'Image'
  }

  updateFilterCounts(assets) {
    // reset counts
    for (const fkey in this.filterCount) {
      this.filterCount[fkey] = 0;
    }
    for (const asset of assets) {
      if (!!asset.categorie) this.filterCount[asset.categorie]++;
      if (!!asset.filters) {
        for (const fname of asset.filters) {
          this.filterCount[fname]++;
        }
      }
    }
  }

  processAssets(data) {
    let wFilters = [];
    let eFilters = [];

    this.filterCount = {};

    // TODO: keep the current logic, but use uniform casing style
    let selected_assets = [];
    // go through all assets, and set them to the right group
    for (let asset of data) {
      if (!!this.config.status && asset.status != this.config.status) continue;
      selected_assets.push(asset);
      let catkey: string;
      if (!!asset.categorie) {
        catkey = asset.categorie;
      } else {
        catkey = this.get_cat(asset.SKU);
        asset.categorie = catkey;
      }
      if (!this.filterCount[catkey]) {
        this.filterCount[catkey] = 0;
        eFilters.push({
          key: catkey,
          group: 'e',
          weight: 1,
          title: catkey,
          active: false,
          asset_allowed: true,
          asset_only: true,
        });
      }
      this.filterCount[catkey]++;

      if (!!asset.filters && asset.filters.length > 0) {
        for (let filter_key of asset.filters) {
          if (!this.filterCount[filter_key]) {
            this.filterCount[filter_key] = 0;
            const w = this.predefined_list.indexOf(filter_key);
            wFilters.push({
              key: filter_key,
              group: 'w',
              weight: w,
              title: filter_key,
              active: false,
              asset_allowed: false,
              asset_only: false,
            });
          }
          this.filterCount[filter_key]++;
          if (!!asset.is_asset) {
            for (let f of wFilters) {
              if (f.key == filter_key) {
                f.asset_only = true;
              }
            }
          }
        }
      }
    }
    // sort the filters
    wFilters = wFilters.sort((a, b) => {
      return a.weight - b.weight;
    });
    eFilters = eFilters.sort((a, b) => {
      return a.weight - b.weight;
    });
    // TODO: use the filters as input to the filterbar comp
    // make one filter list.
    // TODO: get group names from data?
    this.translatedAssetFilters = [];
    if (!!this.config.categories && eFilters.length > 0) {
      this.translatedAssetFilters.push({ title: "Bestandstype", filters: eFilters });
      this.activeFilterGroups[eFilters[0].group] = [];
    }
    if (wFilters.length > 0) {
      this.translatedAssetFilters.push({ title: "Categorie", filters: wFilters });
      this.activeFilterGroups[wFilters[0].group] = [];
    }

    this.filteredAssets = selected_assets;
    this.assets = selected_assets;

    // if we have an active param from the location, set this to active through searchsplice(this.activeFilters.indexOf(filter), 1)
    if (!!this.paramFilter) {
      // don't forget to set a group, or else it won't filter subpages as Zoom! training page
      this.onFilter({ title: this.paramFilter, active: true, group: 'w' });
    }
  }

  onSearch(keywords: string) {
    // do something with the search value

    this.resetSearch();
    console.log("starting search");
    this.activeKeywords = keywords;

    const searchTerms = this.activeKeywords.trim().split(/\s+/).filter(x => x); // prevent empty keywords!
    // first check for active filters
    if (this.activeFilters.length > 0) {
      for (const group_name in this.activeFilterGroups) {
        // console.log(group_name);
        // filter each group for AND logic
        if (this.activeFilterGroups[group_name].length > 0) {
          this.filteredAssets = this.filteredAssets.filter((asset) => {
            for (const filter of this.activeFilterGroups[group_name]) {
              if (asset.filters.includes(filter.title) || asset.categorie === filter.title) {
                // console.log(asset);
                return asset;
              }
            }
          });
        }
      }
    }
    // this.updateFilterCounts(this.filteredAssets);

    // now filter the results down again. Improve this in the future
    this.filteredAssets = this.filteredAssets.filter((asset) => {
      let nmbrOfSearchTerms = 0;
      const searchableString = JSON.stringify(asset).toLowerCase();
      for (const word of searchTerms) {
        if (searchableString.includes(word.toLowerCase())) {
          nmbrOfSearchTerms++;
        }
      }
      if (nmbrOfSearchTerms === searchTerms.length) {
        return asset;
      }
    });
    // ??
    this.updateFilterCounts(this.filteredAssets);
  }

  onFilter(filter) {
    if (filter.active && !this.activeFilters.includes(filter)) {
      this.activeFilters.push(filter);
      this.activeFilterGroups[filter.group].push(filter);
    } else if (this.activeFilters.includes(filter)) {
      this.activeFilters.splice(this.activeFilters.indexOf(filter), 1);
      this.activeFilterGroups[filter.group].splice(this.activeFilters.indexOf(filter), 1);
    }
    this.onSearch(this.activeKeywords);
  }

  resetSearch() {
    this.filteredAssets = this.assets;
  }

  setPreviewOrPrintMode(params) {
    this.config.previewMode = true;
    this.config.printMode = !!params["print"];
    this.dataService.get_assets().subscribe(
      (alist) => {
        for (let a of alist) {
          if (a.id == params["pid"]) {
            this.selectedAsset = this.dataService._translate_object(a);


            try {
              this.selectedAsset.ext = this.selectedAsset.docs
                .split(".")
                .slice(-1)[0];
            } catch (e) {
              this.selectedAsset.ext = "???";
            }
            break;
          }
        }
      },
      (error) => {
        this.selectedAsset = undefined;
      }
    );
  }

  // onPrint(event) {
  //   this.config.printMode = false;
  // }
}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/assets-page/assets-page.component.ts